import { metaHelper } from '@customerio/dryad';
import { createBuilderHook } from '@customerio/dryad-react';
import { flatFilterAdapter, FLAT_FILTER_FORMAT, type CollectionFilterBuilderMeta } from './dryad-utils';

// Views are registered by the component that owns them, not wired in here:
// a row needs this builder for its typed useMeta/useLeafState, so importing
// rows from this module would make the pair circular.
export const collectionFilterBuilder = createBuilderHook({
  formatAdapters: { [FLAT_FILTER_FORMAT]: flatFilterAdapter },
  maxDepth: 1,
  meta: metaHelper<CollectionFilterBuilderMeta>(),
});
